import { useDispatch } from 'react-redux'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { TextEditor } from 'components/ideal-core-ui'
import { makePutRequest } from 'utils/api'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import s from './SignatureModal.scss'

const Signature = ({ signature, setSignature, isSignatureModalVisible, toggleSignatureModal }) => {
  const reduxDispatch = useDispatch()

  const saveSignature = async (signature, title, destroyEditor) => {
    try {
      const response = await makePutRequest('/v1/users/signature', { signature })
      setSignature(response.signature)
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Signature updated successfuly',
          level: 'success'
        }
      })
    } catch (e) {
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'An error occurred. Please contact support',
          level: 'error'
        }
      })
    }
    destroyEditor && destroyEditor()
    toggleSignatureModal()
  }
  return (
    <Modal keyboard={false} backdrop="static" isOpen={isSignatureModalVisible} size="xl">
      <ModalHeader className={s.modalHeader}>Create or edit your signature</ModalHeader>
      <ModalBody className={s.modalBody}>
        <div className={s.content}>
          <p>This signature will be retrieved in the emails you send out from the iDeal system.</p>
          <TextEditor
            template={signature}
            actions={[
              {
                text: 'Save',
                cb: (body, title, subject, destroyEditor) => {
                  saveSignature(body, title, destroyEditor)
                },
                className: s.saveBtn
              },
              {
                text: 'Cancel',
                cb: (body, title, subject, destroyEditor) => {
                  destroyEditor && destroyEditor()
                  toggleSignatureModal()
                },
                className: s.cancelBtn
              }
            ]}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default Signature
